import { Heading } from "../../../../../../../../components/headers/heading/heading.component";
import React from "react";
import { FlyerDetailAddPageTemplateGroupHeaderProps } from "./flyer-detail-add-page-template-group-header.props";

export const FlyerDetailAddPageTemplateGroupHeader = (
  props: FlyerDetailAddPageTemplateGroupHeaderProps
) => <Heading variant="sub">{props.templateGroup.positions} Feature Blocks</Heading>;
